import styled from 'styled-components';

export const ErrorWrapper = styled.div`
    //background-image: url('/assets/images/player/player-loading.png');
    height: 100vh;
    //background-size: cover;
    //filter: grayscale(1);
    
    //&:before {
    //    content: '';
    //    position: absolute;
    //    top: 0;
    //    left: 0;
    //    width: 100%;
    //    height: 100%;
    //    background: radial-gradient(circle, transparent 50%, black 100%);
    //    mask-image: radial-gradient(circle, white 50%, black 100%);
    //    -webkit-mask-image: radial-gradient(circle, white 50%, black 100%);
    //    z-index: 1;
    //    pointer-events: none;
    //}
`;


export const ErrorCodeContainer = styled.div`
    font-size: 40vw;
    color: #212121;
    font-weight: 900;
    text-align: center;
    height: 100vh;
    opacity: .4;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    left: 0;
    right: 0;
`

export const ErrorLabel = styled.div`
    font-size: 3vw;
    color: #f9f9f9;
    opacity: .4;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width:100%;
`
